import React, {useContext, useMemo} from 'react';
import {AuthContext} from '../../../../contexts/AuthContext';
import {getBudgetYearForProperty, useProperties} from '../../../../contexts/properties/PropertiesContext';
import * as css from './BudgetYearDropdown.module.scss';
import {ViziblyTheme} from "../../../../styles/zendesk-garden/ViziblyZDGTheme";
import {ThemeProvider} from "styled-components";
import {Dropdown, Field, Item, Menu, Select} from "@zendeskgarden/react-dropdowns";
import {Tooltip} from "@zendeskgarden/react-tooltips";
import {ReactComponent as InfoIcon} from '@zendeskgarden/svg-icons/src/16/info-stroke.svg';

export const BudgetYearDropdown: React.FC = () => {
    const auth = useContext(AuthContext);
    const {currentProperty} = useProperties();

    const currentBudgetYear = useMemo(() => {
        return getBudgetYearForProperty(currentProperty, auth.budgetYear);
    }, [currentProperty, auth.budgetYear]);


    if (auth.budgetYearsList.length === 0) {
        return null;
    }

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <div className={css.budgetYearsDropDownArea}>
                <Tooltip
                    type="light"
                    content={"Selecting Budget Year allows you to view your budgets created in Vizibly for different years"}
                >
                    <InfoIcon />
                </Tooltip>
                <Dropdown
                    selectedItem={currentBudgetYear}
                    onSelect={(v) => auth.setBudgetYear(v)}
                >
                    <Field>
                        <Select disabled={auth.budgetYearsList.length < 2 || currentProperty?.isAcquisitionProperty} className={css.dropdown}>
                            {currentProperty?.isAcquisitionProperty ? currentProperty.acquisitionBudgetYear : currentBudgetYear}
                        </Select>
                    </Field>
                    <Menu>
                        {auth.budgetYearsList.map((bYear) =>
                            <Item key={bYear} value={bYear}>
                                {bYear}
                            </Item>
                        ) ?? null}
                    </Menu>
                </Dropdown>
            </div>
        </ThemeProvider>
    );
};
